import { Component, Input, OnChanges } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { NgIf } from '@angular/common'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { ContainerTrackElement } from '../../../../phaser/game-objects/groups/track/track.element'
import { buildEventInformationLabel } from '../live-event-view-model'
import { LiveEvent } from '../../../core/models/live-events'

@Component({
  selector: 'app-general-information',
  standalone: true,
  imports: [IonicModule, NgIf, TranslateModule],
  templateUrl: './general-information.component.html',
  styleUrl: './general-information.component.scss',
})
export class GeneralInformationComponent implements OnChanges {
  @Input() stationInformation: ContainerTrackElement
  @Input() event: LiveEvent

  eventInformationLabel: string

  constructor(private translate: TranslateService) {}

  async ngOnChanges() {
    this.eventInformationLabel = await buildEventInformationLabel({
      translationService: this.translate,
      eventsCount: this.stationInformation?.liveEventElement?.getEventsCount(),
    })
  }
}
